<template>
	<div
		class="g-block-body-bg g-block-body-padding"
		:class="{
			'g-block-body-bg--edit': editable,
			'is-active': editable && active,
			'g-block-body-bg--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-body-bg__panel"
			:style="{ background: bgColor }"
		>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-bg__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-bg__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getBodyBgColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyBg',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			bgColor() {
				return getBodyBgColor(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-bg {
		.body-block-edit-shell();
	}

	.g-block-body-bg__panel {
		border-radius: 6px;
		padding: 12px 14px;
		box-sizing: border-box;
	}

	.g-block-body-bg__text {
		.body-text-base();
	}

	.g-block-body-bg--h5 {
		.g-block-body-bg__panel {
			border-radius: 0.12rem;
			padding: 0.24rem 0.28rem;
		}
		.body-text-base--h5(~'.g-block-body-bg__text');
	}
</style>
